import { render, staticRenderFns } from "./index.vue?vue&type=template&id=353c9f64&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353c9f64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('353c9f64')) {
      api.createRecord('353c9f64', component.options)
    } else {
      api.reload('353c9f64', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=353c9f64&scoped=true", function () {
      api.rerender('353c9f64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/modular/index.vue"
export default component.exports